<template>
	<section class="other_page_banner devpay">
		<div class="container">
			<div class="row">
				<div class="col-sm-6 order-2 order-md-1">
					<div class="ban_lt">
						<h2>
							{{
								$t('new_ui.development_main_page.section_banner.main_title.one')
							}}
						</h2>
						<h6>
							{{
								$t('new_ui.development_main_page.section_banner.sub_title.one')
							}}
							<span>
								{{
									$t(
										'new_ui.development_main_page.section_banner.sub_title.two',
									)
								}}
							</span>
						</h6>
					</div>
				</div>
				<div class="col-sm-6 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="franchaise_inn develpment_main_dsk">
		<div class="container">
			<!-- Left Side List -->
			<div class="d-flex align-items-start payment_easy_top">
				<div class="franchaise_inn_lt">
					<div class="franchise_inn_contentbox">
						<h6>
							{{
								$t('new_ui.development_main_page.franchaise_inn_lt.title.one')
							}}
						</h6>

						<div
							class="nav flex-column nav-pills"
							role="tablist"
							aria-orientation="vertical"
						>
							<button
								class="nav-link"
								:class="{ active: activeTab === 'franchise-home' }"
								@click="setActiveTab('franchise-home')"
								type="button"
								role="tab"
							>
								{{
									$t('new_ui.development_main_page.franchaise_inn_lt.title.two')
								}}
							</button>
							<button
								v-if="0"
								class="nav-link"
								:class="{ active: activeTab === 'franchise-profile' }"
								@click="setActiveTab('franchise-profile')"
								type="button"
								role="tab"
							>
								{{
									$t(
										'new_ui.development_main_page.franchaise_inn_lt.title.three',
									)
								}}
							</button>
						</div>
					</div>
				</div>

				<!-- Right Side Content -->
				<div class="franchaise_inn_rt">
					<!-- Franchise Agreement Content -->
					<div
						v-show="activeTab === 'franchise-home'"
						class="tab-content-section"
					>
						<h5 class="franchise_hed">
							<span>{{
								$t('new_ui.development_main_page.franchaise_inn_rt.label')
							}}</span>
						</h5>
						<div class="franchaise_box devmain">
							<h4>
								{{
									$t('new_ui.development_main_page.franchaise_inn_rt.title.one')
								}}
								<span>{{
									$t('new_ui.development_main_page.franchaise_inn_rt.title.two')
								}}</span>
							</h4>
							<div class="dev_enjoy">
								<div class="enjoy_shopping_sec">
									<div class="enjoy_shopping_box_sec">
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image2" alt="" />
												<div class="offer_round">1</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.development_main_page.enjoy_shopping_dwn_1st.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.development_main_page.enjoy_shopping_dwn_1st.title',
														)
													}}
												</p>
											</div>
										</div>

										<div class="enjoy_shopping_inn shoping_mid">
											<div class="enjoy_shopping_box">
												<img :src="img.image3" alt="" />
												<div class="offer_round offer_round2">2</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.development_main_page.enjoy_shopping_dwn_2nd.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.development_main_page.enjoy_shopping_dwn_2nd.title',
														)
													}}
												</p>
											</div>
										</div>
									</div>
								</div>
								<div class="enjoy_shopping_sec">
									<div class="enjoy_shopping_box_sec">
										<div class="enjoy_shopping_inn payment_arw">
											<div class="enjoy_shopping_box">
												<img :src="img.image4" alt="" />
												<div class="offer_round offer_round2">4</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.development_main_page.enjoy_shopping_dwn_3rd.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.development_main_page.enjoy_shopping_dwn_3rd.title',
														)
													}}
												</p>
											</div>
										</div>

										<div class="enjoy_shopping_inn dwn_crv">
											<div class="enjoy_shopping_box">
												<img :src="img.image5" alt="" />
												<div class="offer_round">3</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.development_main_page.enjoy_shopping_dwn_4th.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.development_main_page.enjoy_shopping_dwn_4th.title',
														)
													}}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div
						v-show="activeTab === 'franchise-home'"
						class="tab-content-section mtop"
					></div>

					<!-- Other Franchise Agreement tabs -->
					<div
						v-show="activeTab === 'franchise-profile'"
						class="tab-content-section"
					>
						<h5 class="franchise_hed">
							<span>{{
								$t('new_ui.development_main_page.easypayment_main.label')
							}}</span>
						</h5>
						<div class="franchaise_box devmain">
							<h4>
								{{
									$t('new_ui.development_main_page.easypayment_main.title.one')
								}}
								<span>{{
									$t('new_ui.development_main_page.easypayment_main.title.two')
								}}</span>
							</h4>
							<div class="easy_pay_sec">
								<div class="easy_pay_sec_top">
									<div class="easy_pay_sec_top_up">
										<h6>
											{{
												$t(
													'new_ui.development_main_page.easypayment_main.main_title',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.development_main_page.easypayment_main.paragraph',
												)
											}}
										</p>
									</div>
									<div class="easy_pay_sec_top_dwn">
										<ul>
											<li>
												{{
													$t(
														'new_ui.development_main_page.easypayment_main.link.one',
													)
												}}
											</li>
											<li>
												{{
													$t(
														'new_ui.development_main_page.easypayment_main.link.two',
													)
												}}
											</li>
											<li>
												{{
													$t(
														'new_ui.development_main_page.easypayment_main.link.three',
													)
												}}
											</li>
										</ul>
									</div>
								</div>
								<div class="easy_pay_sec_dwn">
									<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
										<li class="nav-item" role="presentation">
											<button
												class="nav-link active"
												id="pills-home-tab"
												data-bs-toggle="pill"
												data-bs-target="#pills-home"
												type="button"
												role="tab"
												aria-controls="pills-home"
												aria-selected="true"
											>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_1st.label',
													)
												}}
											</button>
										</li>
										<li class="nav-item" role="presentation">
											<button
												class="nav-link"
												id="pills-profile-tab"
												data-bs-toggle="pill"
												data-bs-target="#pills-profile"
												type="button"
												role="tab"
												aria-controls="pills-profile"
												aria-selected="false"
											>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_2nd.label',
													)
												}}
											</button>
										</li>
										<li class="nav-item" role="presentation">
											<button
												class="nav-link"
												id="pills-contact-tab"
												data-bs-toggle="pill"
												data-bs-target="#pills-contact"
												type="button"
												role="tab"
												aria-controls="pills-contact"
												aria-selected="false"
											>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_3rd.label',
													)
												}}
											</button>
										</li>
										<li class="nav-item" role="presentation">
											<button
												class="nav-link"
												id="pills-all-tab"
												data-bs-toggle="pill"
												data-bs-target="#pills-all"
												type="button"
												role="tab"
												aria-controls="pills-all"
												aria-selected="false"
											>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_2nd.label',
													)
												}}
											</button>
										</li>
									</ul>
									<div class="tab-content pay_tabbox" id="pills-tabContent">
										<div
											class="tab-pane fade show active"
											id="pills-home"
											role="tabpanel"
											aria-labelledby="pills-home-tab"
										>
											<div class="easy_pay_sec_dwn_content">
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_1st.paragraph1.one',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_1st.paragraph1.two',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content2">
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_1st.paragraph1.three',
														)
													}}</a>
													<a href="" class="yellow">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_1st.paragraph1.four',
														)
													}}</a>
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_1st.paragraph1.five',
														)
													}}</a>
												</div>
											</div>
											<div class="easy_pay_sec_dwn_content">
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_1st.paragraph2.one',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_1st.paragraph2.two',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content2">
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_1st.paragraph2.three',
														)
													}}</a>
													<a href="" class="yellow">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_1st.paragraph2.four',
														)
													}}</a>
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_1st.paragraph2.five',
														)
													}}</a>
												</div>
											</div>
										</div>
										<div
											class="tab-pane fade"
											id="pills-profile"
											role="tabpanel"
											aria-labelledby="pills-profile-tab"
										>
											<div class="easy_pay_sec_dwn_content">
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.one',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.two',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content2">
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.three',
														)
													}}</a>
													<a href="" class="yellow">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.four',
														)
													}}</a>
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.five',
														)
													}}</a>
												</div>
											</div>
											<div class="easy_pay_sec_dwn_content">
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.one',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.two',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content2">
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.three',
														)
													}}</a>
													<a href="" class="yellow">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.four',
														)
													}}</a>
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.five',
														)
													}}</a>
												</div>
											</div>
										</div>
										<div
											class="tab-pane fade"
											id="pills-contact"
											role="tabpanel"
											aria-labelledby="pills-contact-tab"
										>
											<div class="easy_pay_sec_dwn_content">
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.one',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.two',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content2">
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.three',
														)
													}}</a>
													<a href="" class="yellow">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.four',
														)
													}}</a>
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.five',
														)
													}}</a>
												</div>
											</div>
											<div class="easy_pay_sec_dwn_content">
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.one',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.two',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content2">
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.three',
														)
													}}</a>
													<a href="" class="yellow">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.four',
														)
													}}</a>
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.five',
														)
													}}</a>
												</div>
											</div>
										</div>
										<div
											class="tab-pane fade"
											id="pills-all"
											role="tabpanel"
											aria-labelledby="pills-all-tab"
										>
											<div class="easy_pay_sec_dwn_content">
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_4th.paragraph1.one',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_4th.paragraph1.two',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content2">
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_4th.paragraph1.three',
														)
													}}</a>
													<a href="" class="yellow">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_4th.paragraph1.four',
														)
													}}</a>
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_4th.paragraph1.five',
														)
													}}</a>
												</div>
											</div>
											<div class="easy_pay_sec_dwn_content">
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_4th.paragraph2.one',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content1">
													<p>
														{{
															$t(
																'new_ui.development_main_page.easypayment_tab_4th.paragraph2.two',
															)
														}}
													</p>
												</div>
												<div class="easy_pay_sec_dwn_content2">
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_4th.paragraph2.three',
														)
													}}</a>
													<a href="" class="yellow">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_4th.paragraph2.four',
														)
													}}</a>
													<a href="">{{
														$t(
															'new_ui.development_main_page.easypayment_tab_4th.paragraph2.five',
														)
													}}</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-show="activeTab === 'franchise-messages'"
						class="tab-content-section"
					>
						.3..
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="develpment_main_mob">
		<div class="custom-select-wrapper">
			<select
				name="cars"
				id="franchise_item"
				class="custom-select"
				v-model="easypaymentDropdown"
			>
				<option value="ram">
					{{ $t('new_ui.development_main_page.easypayment_mob.label.one') }}
				</option>
				<option v-if="0" value="ep">
					{{ $t('new_ui.development_main_page.easypayment_mob.label.two') }}
				</option>
			</select>
			<i class="fa fa-chevron-down"></i>
		</div>

		<div class="franchaise_mob_accordian devmain">
			<img class="w-100" style="margin: 10px 0 30px" :src="img.image6" alt="" />
			<div v-if="easypaymentDropdown === 'ram'">
				<h4>
					{{ $t('new_ui.development_main_page.franchaise_inn_rt.title.one') }}
					<span>{{
						$t('new_ui.development_main_page.franchaise_inn_rt.title.two')
					}}</span>
				</h4>
				<div class="enjoy_slider">
					<swiper
						:slides-per-view="1"
						:space-between="30"
						:loop="true"
						:pagination="{
							el: '.swiper-pagination-2',
							clickable: true,
						}"
						:autoplay="{ delay: 2000, disableOnInteraction: false }"
						:breakpoints="{
							0: { slidesPerView: 1 },
							600: { slidesPerView: 1.5 },
							768: { slidesPerView: 2 },
							1000: { slidesPerView: 3 },
							1200: { slidesPerView: 4.5 },
						}"
					>
						<swiper-slide>
							<div class="enjoy_shopping_inn">
								<div class="enjoy_shopping_box">
									<img :src="img.image2" alt="" />
									<div class="offer_round">1</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t(
												'new_ui.development_main_page.enjoy_shopping_dwn_1st.label',
											)
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.development_main_page.enjoy_shopping_dwn_1st.title',
											)
										}}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="enjoy_shopping_inn">
								<div class="enjoy_shopping_box">
									<img :src="img.image3" alt="" />
									<div class="offer_round offer_round2">2</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t(
												'new_ui.development_main_page.enjoy_shopping_dwn_2nd.label',
											)
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.development_main_page.enjoy_shopping_dwn_2nd.title',
											)
										}}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="enjoy_shopping_inn">
								<div class="enjoy_shopping_box">
									<img :src="img.image5" alt="" />
									<div class="offer_round">3</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t(
												'new_ui.development_main_page.enjoy_shopping_dwn_3rd.label',
											)
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.development_main_page.enjoy_shopping_dwn_3rd.title',
											)
										}}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="enjoy_shopping_inn">
								<div class="enjoy_shopping_box">
									<img :src="img.image4" alt="" />
									<div class="offer_round">4</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t(
												'new_ui.development_main_page.enjoy_shopping_dwn_4th.label',
											)
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.development_main_page.enjoy_shopping_dwn_4th.title',
											)
										}}
									</p>
								</div>
							</div>
						</swiper-slide>
					</swiper>
					<!-- Move pagination outside swiper -->
					<div class="swiper-pagination-2"></div>
				</div>
			</div>
			<div v-if="easypaymentDropdown === 'ep'" class="easy_payment">
				<h5 class="franchise_hed"></h5>
				<div class="franchaise_box devmain">
					<h4>
						{{ $t('new_ui.development_main_page.easypayment_main.title.one') }}
						<span>{{
							$t('new_ui.development_main_page.easypayment_main.title.two')
						}}</span>
					</h4>
					<div class="easy_pay_sec">
						<div class="easy_pay_sec_top">
							<div class="easy_pay_sec_top_up">
								<h6>
									{{
										$t(
											'new_ui.development_main_page.easypayment_main.main_title',
										)
									}}
								</h6>
								<p>
									{{
										$t(
											'new_ui.development_main_page.easypayment_main.paragraph',
										)
									}}
								</p>
							</div>
							<div class="easy_pay_sec_top_dwn">
								<ul>
									<li>
										{{
											$t(
												'new_ui.development_main_page.easypayment_main.link.one',
											)
										}}
									</li>
									<li>
										{{
											$t(
												'new_ui.development_main_page.easypayment_main.link.two',
											)
										}}
									</li>
									<li>
										{{
											$t(
												'new_ui.development_main_page.easypayment_main.link.three',
											)
										}}
									</li>
								</ul>
							</div>
						</div>
						<div class="easy_pay_sec_dwn">
							<!-- Dropdown for Mobile -->
							<div class="d-block d-md-none">
								<select class="form-select" v-model="selectedTab">
									<option value="tab-one">
										{{
											$t(
												'new_ui.development_main_page.easy_pay_sec_dwn.option.one',
											)
										}}
									</option>
									<option value="tab-two">
										{{
											$t(
												'new_ui.development_main_page.easy_pay_sec_dwn.option.two',
											)
										}}
									</option>
									<option value="tab-three">
										{{
											$t(
												'new_ui.development_main_page.easy_pay_sec_dwn.option.three',
											)
										}}
									</option>
									<option value="tab-four">
										{{
											$t(
												'new_ui.development_main_page.easy_pay_sec_dwn.option.four',
											)
										}}
									</option>
								</select>
							</div>
							<!-- Tabs for Desktop -->

							<div class="tab-content pay_tabbox" id="pills-tabContent">
								<div
									v-if="selectedTab === 'tab-one'"
									class="tab-pane fade show active"
									id="pills-home1"
									role="tabpanel"
									aria-labelledby="pills-home-tab"
								>
									<div class="easy_pay_sec_dwn_content">
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_1st.paragraph1.one',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_1st.paragraph1.two',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content2">
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_1st.paragraph1.three',
												)
											}}</a>
											<a href="" class="yellow">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_1st.paragraph1.four',
												)
											}}</a>
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_1st.paragraph1.five',
												)
											}}</a>
										</div>
									</div>
									<div class="easy_pay_sec_dwn_content">
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_1st.paragraph2.one',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_1st.paragraph2.two',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content2">
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_1st.paragraph2.three',
												)
											}}</a>
											<a href="" class="yellow">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_1st.paragraph2.four',
												)
											}}</a>
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_1st.paragraph2.five',
												)
											}}</a>
										</div>
									</div>
								</div>

								<div
									v-if="selectedTab === 'tab-two'"
									class="tab-pane fade show active"
									id="pills-home1"
									role="tabpanel"
									aria-labelledby="pills-home-tab"
								>
									<div class="easy_pay_sec_dwn_content">
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.one',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.two',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content2">
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.three',
												)
											}}</a>
											<a href="" class="yellow">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.four',
												)
											}}</a>
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_2nd.paragraph1.five',
												)
											}}</a>
										</div>
									</div>
									<div class="easy_pay_sec_dwn_content">
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.one',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.two',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content2">
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.three',
												)
											}}</a>
											<a href="" class="yellow">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.four',
												)
											}}</a>
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_2nd.paragraph2.five',
												)
											}}</a>
										</div>
									</div>
								</div>

								<div
									v-if="selectedTab === 'tab-three'"
									class="tab-pane fade show active"
									id="pills-home1"
									role="tabpanel"
									aria-labelledby="pills-home-tab"
								>
									<div class="easy_pay_sec_dwn_content">
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.one',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.two',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content2">
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.three',
												)
											}}</a>
											<a href="" class="yellow">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.four',
												)
											}}</a>
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_3rd.paragraph1.five',
												)
											}}</a>
										</div>
									</div>
									<div class="easy_pay_sec_dwn_content">
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.one',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.two',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content2">
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.three',
												)
											}}</a>
											<a href="" class="yellow">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.four',
												)
											}}</a>
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_3rd.paragraph2.five',
												)
											}}</a>
										</div>
									</div>
								</div>

								<div
									v-if="selectedTab === 'tab-four'"
									class="tab-pane fade show active"
									id="pills-home1"
									role="tabpanel"
									aria-labelledby="pills-home-tab"
								>
									<div class="easy_pay_sec_dwn_content">
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_4th.paragraph1.one',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_4th.paragraph1.two',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content2">
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_4th.paragraph1.three',
												)
											}}</a>
											<a href="" class="yellow">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_4th.paragraph1.four',
												)
											}}</a>
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_4th.paragraph1.five',
												)
											}}</a>
										</div>
									</div>
									<div class="easy_pay_sec_dwn_content">
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_4th.paragraph2.one',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content1">
											<p>
												{{
													$t(
														'new_ui.development_main_page.easypayment_tab_4th.paragraph2.two',
													)
												}}
											</p>
										</div>
										<div class="easy_pay_sec_dwn_content2">
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_4th.paragraph2.three',
												)
											}}</a>
											<a href="" class="yellow">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_4th.paragraph2.four',
												)
											}}</a>
											<a href="">{{
												$t(
													'new_ui.development_main_page.easypayment_tab_4th.paragraph2.five',
												)
											}}</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.development_main_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.development_main_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.development_main_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.development_main_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.development_main_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.development_main_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.development_main_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import devpay from '@/assets/images/sub/devpay.png';
import choose from '@/assets/images/sub/Choose.png';
import handmobile from '@/assets/images/sub/handmobile.png';
import login from '@/assets/images/sub/Login.png';
import invoice from '@/assets/images/sub/invoice.png';
import linearw from '@/assets/images/sub/line_arow.png';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);

export default {
	data() {
		return {
			img: {
				image1: devpay,
				image2: choose,
				image3: login,
				image4: invoice,
				image5: handmobile,
				image6: linearw,
			},
			activeTab: 'franchise-home', // Set default active tab
			easypaymentDropdown: 'ram',
			selectedTab: 'tab-one',
		};
	},
	methods: {
		setActiveTab(tabName) {
			this.activeTab = tabName;
		},
	},
};
</script>
